import { render, staticRenderFns } from "./PostText.vue?vue&type=template&id=f5799a0e&scoped=true&"
import script from "./PostText.vue?vue&type=script&lang=js&"
export * from "./PostText.vue?vue&type=script&lang=js&"
import style0 from "./PostText.vue?vue&type=style&index=0&id=f5799a0e&lang=scss&scoped=true&"
import style1 from "./PostText.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5799a0e",
  null
  
)

export default component.exports